export default "__VITE_ASSET__zgY6GPNc__"